import { render, staticRenderFns } from "./ContactsCardDialog.vue?vue&type=template&id=ade859ee&scoped=true"
import script from "./ContactsCardDialog.vue?vue&type=script&lang=js"
export * from "./ContactsCardDialog.vue?vue&type=script&lang=js"
import style0 from "./ContactsCardDialog.vue?vue&type=style&index=0&id=ade859ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ade859ee",
  null
  
)

export default component.exports